import Mustache from 'mustache';
import showdown from 'showdown';

const converter = new showdown.Converter();

const render = (template, view) => converter.makeHtml(Mustache.render(template, view));

export default render;
